import { Utils } from "neo-common";
import { Communication } from "neo-games";
import { GambleController } from "./GambleController";
import { DataManager } from "../../Managers/DataManager";
import { GameManager } from "../../Managers/GameManager";
import { MessageManager } from "../../Managers/MessageManager";

export class GambleModel {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    protected controller: GambleController;

    //******************************************************************************************************************
    //  CONSTRUCTOR
    //******************************************************************************************************************

    constructor(controller: GambleController) {
        this.controller = controller;
    }

    //******************************************************************************************************************
    //  REQUESTS
    //******************************************************************************************************************

    public start(): void {
        if (GameManager.requestSend) {
            return;
        }

        GameManager.requestSend = true;

        DataManager.controlAutoplay();
        GameManager.gameClient.start(Communication.Game.GameModules.Gamble).then((response: any): any => {
            MessageManager.postpone(this.startReceived.bind(this), response);
        });
    }

    public select(color: Communication.Game.Color): void {
        if (GameManager.requestSend) {
            return;
        }

        GameManager.requestSend = true;

        DataManager.controlAutoplay();
        GameManager.gameClient.gambleSelect(color).then((response: any): any => {
            MessageManager.postpone(this.selectReceived.bind(this), response);
        });
    }

    public halve(): void {
        if (GameManager.requestSend) {
            return;
        }

        GameManager.requestSend = true;

        DataManager.controlAutoplay();
        GameManager.gameClient.gambleHalve(Communication.Game.GameModules.Gamble).then((response: any): any => {
            MessageManager.postpone(this.halveReceived.bind(this), response);
        });
    }

    //******************************************************************************************************************
    //  RESPONSES
    //******************************************************************************************************************

    protected startReceived(response: Communication.Game.GameResponse): void {
        if (!Utils.isNullOrUndefined(response)) {
            GameManager.parseResponses(response);
            DataManager.updateResponseData();

            this.controller.startReceived();
        }

        GameManager.requestSend = false;
    }

    protected selectReceived(response: Communication.Game.GameResponse): void {
        if (!Utils.isNullOrUndefined(response)) {
            GameManager.parseResponses(response);
            DataManager.updateResponseData();

            this.controller.selectReceived();
        }

        GameManager.requestSend = false;
    }

    protected halveReceived(response: Communication.Game.GameResponse): void {
        if (!Utils.isNullOrUndefined(response)) {
            GameManager.parseResponses(response);
            DataManager.updateResponseData();

            this.controller.halveReceived();
        }

        GameManager.requestSend = false;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Gamble/GambleModel.ts
 **/